import React, { useContext } from 'react';

/**
 * Provides information about the current step in Stepper.
 */
var StepperContext = React.createContext({});
/**
 * Returns the current StepperContext or an empty object if no StepperContext
 * has been defined in the component tree.
 */
function useStepperContext() {
    return useContext(StepperContext);
}

export { StepperContext as default, useStepperContext };
//# sourceMappingURL=StepperContext.esm.js.map
